import { FormSelectDataType, FormSelectIdType } from '@systemeio/ui'

export const getFormSelectData = <T extends FormSelectIdType>(
  data: { id: T; name: string }[],
): FormSelectDataType<T>[] => {
  return data.map(instance => ({
    id: instance.id,
    caption: instance.name,
  }))
}
